// @flow
import {createReducer} from 'modules/redux/reducer';
import {TRAINING_MODULES_ACTION_TYPES} from 'modules/trainingModules/constants';
import type {TGameSession, TNormTrainingModules, TResponseGameModuleChapters} from 'modules/trainingModules/types';

export type TSetTrainingModules = {payload: TNormTrainingModules, type: string};
export type TSetGameModuleSession = {payload: TGameSession, type: string};
export type TTrainingModulesState = {
    chapters: TResponseGameModuleChapters,
    data: TNormTrainingModules,
    games: TGameSession,
};
export type TSetTrainingModulesChapters = {
    payload: TResponseGameModuleChapters,
    type: string,
};
const reducer = {
    [TRAINING_MODULES_ACTION_TYPES.GET_GAME_MODULES]: (state, payload) => {
        return {
            ...state,
            data: payload,
        };
    },
    [TRAINING_MODULES_ACTION_TYPES.SET_GAME_MODULE_SESSION]: (state, payload) => {
        return {
            ...state,
            games: {
                ...payload,
            },
        };
    },
    [TRAINING_MODULES_ACTION_TYPES.GET_GAME_MODULES_CHAPTERS]: (state, payload) => {
        return {
            ...state,
            chapters: payload,
        };
    },
};
const initialState: TTrainingModulesState = {
    chapters: {},
    data: {},
    games: {},
};
export const trainingModulesReducer = createReducer(initialState, reducer);
